/**
 * Sekme arka plandayken dikkat çekici document.title rotasyonu.
 * Meta / SEO etkilenmez; yalnızca canlı sekme başlığı değişir.
 */
(function () {
  if (window.__curseTabTitleInit) return;
  window.__curseTabTitleInit = true;

  var originalTitle = document.title;
  var rotateTimer = null;
  var rotateIndex = 0;

  var brand =
    (document.body && document.body.getAttribute('data-curse-brand')) || 'supplement';

  var messages =
    brand === 'vitamin'
      ? [
          'Curse Vitamin seni bekliyor!',
          'Sağlığını destekle!',
          'Curse Vitamin'
        ]
      : [
          ' Sepetin seni bekliyor!',
          '🔥 Geri dön!',
          'Curse Supplement'
        ];

  function clearRotate() {
    if (rotateTimer !== null) {
      clearInterval(rotateTimer);
      rotateTimer = null;
    }
  }

  function startRotate() {
    clearRotate();
    if (!messages.length) return;
    rotateIndex = 0;
    document.title = messages[0];
    rotateTimer = window.setInterval(function () {
      rotateIndex = (rotateIndex + 1) % messages.length;
      document.title = messages[rotateIndex];
    }, 2500);
  }

  function restoreTitle() {
    clearRotate();
    document.title = originalTitle;
  }

  document.addEventListener(
    'visibilitychange',
    function () {
      if (document.hidden) {
        startRotate();
      } else {
        restoreTitle();
      }
    },
    { passive: true }
  );
})();
